import { Box, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const CustomPopper = styled(Box)`
  && {
    .MuiPaper-root {
      box-shadow: none;
      padding: 0;
      border-radius: 0;
      max-height: 125px;
      overflow: hidden;

      & > ul {
        max-height: 125px;
      }
      .MuiAutocomplete-noOptions {
        padding: 0;
      }
    }
  }
`;

export const CustomListItem = styled.li`
  && {
    &.MuiAutocomplete-option[aria-selected='true'] {
      background-color: ${colorPalette.white};
    }
    &.MuiAutocomplete-option.Mui-focused {
      background-color: ${colorPalette.white};
    }
  }
`;

export const NoResultsText = styled(Text)`
  color: ${colorTokens.text.disabled}!important;
  font-weight: 300 !important;
  margin-top: 12px;
  text-align: center;
`;
